import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { environment } from '../../_environments/environment';
import { PricingService } from '../../_service/PricingService';
import { TranslateModule } from '@ngx-translate/core';
import { ChipComponent } from '../chip/chip.component';
import { LowerCasePipe, NgClass } from '@angular/common';
import { PaymentmethodBaseComponent } from './paymentmethod-base.component';

@Component({
    selector: 'paymentmethod',
    templateUrl: './paymentmethod.component.html',
    styleUrls: ['./paymentmethod.component.scss'],
    imports: [
        NgClass,
        ChipComponent,
        LowerCasePipe,
        TranslateModule,
    ]
})
export class PaymentmethodComponent extends PaymentmethodBaseComponent {

  environment = environment;

  constructor(
    _pricingService: PricingService,
    fb: FormBuilder
  ) {
    super(_pricingService, fb);
  }

}
